webpackJsonp([61022679780615],{

/***/ 613:
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),

/***/ 615:
/***/ (function(module, exports) {

	/** Used to match words composed of alphanumeric characters. */
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}
	
	module.exports = asciiWords;


/***/ }),

/***/ 630:
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	var arrayReduce = __webpack_require__(613),
	    deburr = __webpack_require__(668),
	    words = __webpack_require__(690);
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";
	
	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');
	
	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}
	
	module.exports = createCompounder;


/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(630);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),

/***/ 657:
/***/ (function(module, exports) {

	/** Used to detect strings that need a more robust regexp to match words. */
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}
	
	module.exports = hasUnicodeWord;


/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;
	
	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');
	
	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}
	
	module.exports = unicodeWords;


/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(650),
	    toString = __webpack_require__(229);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	var createCompounder = __webpack_require__(645);
	
	/**
	 * Converts `string` to
	 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the kebab cased string.
	 * @example
	 *
	 * _.kebabCase('Foo Bar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('fooBar');
	 * // => 'foo-bar'
	 *
	 * _.kebabCase('__FOO_BAR__');
	 * // => 'foo-bar'
	 */
	var kebabCase = createCompounder(function(result, word, index) {
	  return result + (index ? '-' : '') + word.toLowerCase();
	});
	
	module.exports = kebabCase;


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	var asciiWords = __webpack_require__(615),
	    hasUnicodeWord = __webpack_require__(657),
	    toString = __webpack_require__(229),
	    unicodeWords = __webpack_require__(666);
	
	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;
	
	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}
	
	module.exports = words;


/***/ }),

/***/ 969:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SupportCard = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(9);
	
	var _profilePicture = __webpack_require__(161);
	
	var _locationIconSmall = __webpack_require__(764);
	
	var _locationIconSmall2 = _interopRequireDefault(_locationIconSmall);
	
	var _styles = __webpack_require__(971);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SupportCardComponent = function (_React$PureComponent) {
		_inherits(SupportCardComponent, _React$PureComponent);
	
		function SupportCardComponent() {
			_classCallCheck(this, SupportCardComponent);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		SupportCardComponent.prototype.render = function render() {
			var _ref;
	
			var _props = this.props,
			    to = _props.to,
			    organisation = _props.organisation,
			    location = _props.location,
			    image = _props.image,
			    audiences = _props.audiences,
			    title = _props.title,
			    body = _props.body,
			    type = _props.type;
	
	
			return _react2.default.createElement(
				_link.Link,
				{ className: _styles.wrapperLinkStyle, to: to, 'data-component': 'Card' },
				_react2.default.createElement(
					'article',
					{ className: _styles.wrapperStyle },
					_react2.default.createElement(
						'div',
						null,
						type === 'organisation' && image && _react2.default.createElement(
							'div',
							{ className: _styles.innerStyleOrganisation },
							_react2.default.createElement('img', { src: image, alt: '' })
						),
						type === 'individual' && image && _react2.default.createElement(
							'div',
							{ className: _styles.innerStyleIndividual },
							_react2.default.createElement(_profilePicture.ProfilePicture, {
								image: image,
								size: 130,
								sizesAt: (_ref = {}, _ref[_globalStyles.mobileMaxWidthBreakpoint] = 80, _ref)
							})
						)
					),
					_react2.default.createElement(
						'div',
						null,
						_react2.default.createElement(
							'h1',
							{ className: _styles.titleStyle },
							title
						),
						_react2.default.createElement(
							'div',
							{ className: _styles.organisationStyle },
							_react2.default.createElement(
								'span',
								null,
								organisation,
								' ',
								_react2.default.createElement('img', { src: _locationIconSmall2.default, alt: '' }),
								' ',
								location
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _styles.metaAudiencesStyle },
							audiences.map(function (audience, i) {
								return _react2.default.createElement(
									'span',
									{ key: i, className: (0, _styles.lozengeStyle)(audience.id) },
									audience.title
								);
							})
						),
						_react2.default.createElement(
							'p',
							{ className: _styles.bodyStyle },
							body
						)
					)
				)
			);
		};
	
		return SupportCardComponent;
	}(_react2.default.PureComponent);
	
	SupportCardComponent.propTypes = {
		to: _propTypes2.default.string,
		type: _propTypes2.default.string,
		category: _propTypes2.default.string,
		audiences: _propTypes2.default.array,
		title: _propTypes2.default.string,
		body: _propTypes2.default.string,
		image: _propTypes2.default.string
	};
	
	var SupportCard = exports.SupportCard = SupportCardComponent;

/***/ }),

/***/ 970:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(969);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 971:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapperStyle = exports.bodyStyle = exports.organisationStyle = exports.innerStyleIndividual = exports.innerStyleOrganisation = exports.titleStyle = exports.lozengeStyle = exports.metaAudiencesStyle = exports.wrapperLinkStyle = undefined;
	
	var _css2, _css3, _css4, _css5, _css6;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var padding = 24;
	
	var wrapperLinkStyle = /*#__PURE__*/exports.wrapperLinkStyle = (0, _emotion.css)({
		textDecoration: 'none',
		display: 'block'
	});
	
	var metaAudiencesStyle = /*#__PURE__*/exports.metaAudiencesStyle = (0, _emotion.css)({
		marginBottom: '12px',
		'& span:not(:last-child)': {
			marginRight: '8px'
		}
	});
	
	var lozengeStyle = exports.lozengeStyle = function lozengeStyle(id) {
		var _css;
	
		return (/*#__PURE__*/(0, _emotion.css)((_css = {
				fontWeight: 500,
				fontSize: '10px',
				lineHeight: '12px',
				textTransform: 'uppercase',
				background: _globalStyles.audienceStylesHash[id],
				color: '#fff',
				borderRadius: '11px',
				padding: '4px 8px',
				whiteSpace: 'nowrap',
				display: 'inline-block'
			}, _css['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
				fontSize: '8px',
				lineHeight: '10px'
			}, _css))
		);
	};
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingMediumLight, /*#__PURE__*/(0, _emotion.css)((_css2 = {
		marginTop: '0',
		marginBottom: '4px'
	}, _css2['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '14px',
		lineHeight: '17px'
	}, _css2)));
	
	var innerStyleOrganisation = /*#__PURE__*/exports.innerStyleOrganisation = (0, _emotion.css)((_css3 = {
		width: '130px',
		height: '130px',
		lineHeight: '130px',
		textAlign: 'center',
		marginRight: padding,
		border: '1px solid ' + _globalStyles.lightGrey,
		borderRadius: '6px',
		'& img': {
			maxWidth: '105px'
		}
	}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		width: '80px',
		height: '80px',
		lineHeight: '80px',
		'& img': {
			maxWidth: '55px'
		}
	}, _css3));
	
	var innerStyleIndividual = /*#__PURE__*/exports.innerStyleIndividual = (0, _emotion.css)((_css4 = {
		marginRight: padding
	}, _css4['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		marginRight: padding / 2
	}, _css4));
	
	var organisationStyle = /*#__PURE__*/exports.organisationStyle = (0, _emotion.css)({
		color: '#8A8B8C',
		fontSize: '12px',
		lineHeight: '15px',
		marginBottom: '14px',
		'& img': {
			verticalAlign: 'middle'
		}
	});
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)((_css5 = {
		margin: '0'
	}, _css5['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		display: 'none'
	}, _css5)));
	
	var wrapperStyle = /*#__PURE__*/exports.wrapperStyle = (0, _emotion.css)((_css6 = {
		position: 'relative',
		textDecoration: 'none',
		border: '1px solid ' + _globalStyles.lightGrey,
		borderRadius: '6px',
		width: '100%',
		height: '100%',
		padding: padding + 'px',
		backgroundColor: '#fff',
		boxSizing: 'border-box',
		display: 'table',
		zIndex: '1',
		'& > div': {
			verticalAlign: 'top',
			display: 'table-cell',
			'&:not(:empty):first-child': {
				width: '154px'
			}
		}
	}, _css6['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		padding: '14px 14px 14px 14px',
		'& > div': {
			'&:not(:empty):first-child': {
				width: '104px'
			}
		}
	}, _css6));

/***/ }),

/***/ 764:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 3740:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/bg.146b5127.svg";

/***/ }),

/***/ 1041:
/***/ (function(module, exports) {

	'use strict';
	
	var linkWithFilter = function linkWithFilter(_ref) {
		var parentRegion = _ref.parentRegion,
		    childRegion = _ref.childRegion,
		    page = _ref.page;
	
		var pieces = ['support-organisations', parentRegion || 'all', childRegion || 'all'];
		while (pieces[pieces.length - 1] === 'all') {
			pieces.pop();
		}if ((page || 1) !== 1) pieces.push(page);
		return '/' + pieces.join('/');
	};
	
	module.exports = {
		// Takes the type field like 'inside-out-publications' and swaps dashes for spaces so it can
		// be displayed nicely in the tile.
		typeToDescription: function typeToDescription(type) {
			// fact-sheet becomes Fact Sheet
			return type.split('-').map(function (word) {
				return word.charAt(0).toUpperCase() + word.substring(1);
			}).join(' ');
		},
	
		// When provided with a kebab-case string array of audiences, generates the full object array the component needs
		fullAudiences: function fullAudiences(audiences) {
			return audiences.map(function (audience) {
				switch (audience) {
					case 'for-myself':
						return { id: 'for-myself', title: 'For Myself' };
					case 'family-and-carers':
						return { id: 'family-and-carers', title: 'Family & Carers' };
					case 'for-healthcare-professionals':
						return { id: 'for-healthcare-professionals', title: 'For Healthcare Professionals' };
				}
			}).filter(function (audience) {
				return audience;
			});
		},
	
		audiences: ['for-myself', 'family-and-carers', 'for-healthcare-professionals'],
	
		linkWithFilter: linkWithFilter,
	
		prepareRegions: function prepareRegions(_ref2) {
			var parentRegions = _ref2.parentRegions,
			    childRegions = _ref2.childRegions;
	
			var regions = {};
			var validParents = new Set(parentRegions.edges.map(function (_ref3) {
				var node = _ref3.node;
				return node.title;
			}));
	
			for (var _iterator = validParents, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref4;
	
				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref4 = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref4 = _i.value;
				}
	
				var parent = _ref4;
	
				regions[parent] = [];
			}
	
			for (var _iterator2 = childRegions.edges, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
				var _ref6;
	
				if (_isArray2) {
					if (_i2 >= _iterator2.length) break;
					_ref6 = _iterator2[_i2++];
				} else {
					_i2 = _iterator2.next();
					if (_i2.done) break;
					_ref6 = _i2.value;
				}
	
				var _ref5 = _ref6;
				var node = _ref5.node;
	
				if (validParents.has(node.parent_region)) {
					regions[node.parent_region].push(node.title);
				} else {
					console.warn('- Child Region ' + node.title + ' has an invalid parent and was not connected. Parent: ' + node.parent_region);
				}
			}
	
			return regions;
		}
	};

/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationDropdownStyle = exports.subTitleStyle = exports.titleStyle = exports.tabPageWrapper = exports.locationSelectorInnerStyle = exports.locationSelectorStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _css, _css2, _css3, _css4, _css5, _css6;
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _dropdownIcon = __webpack_require__(235);
	
	var _dropdownIcon2 = _interopRequireDefault(_dropdownIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var locationSelectorStyle = /*#__PURE__*/exports.locationSelectorStyle = (0, _emotion.css)((_css = {
		display: 'none'
	}, _css['@media (min-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		height: '106px',
		width: '100%',
		margin: '0 auto',
		padding: '0 20px',
		display: 'table'
	}, _css));
	
	var locationSelectorInnerStyle = /*#__PURE__*/exports.locationSelectorInnerStyle = (0, _emotion.css)((_css2 = {
		display: 'table-cell',
		verticalAlign: 'middle',
		'& label': _extends({}, _globalStyles.museo500),
		'& select': {
			marginLeft: '20px',
			border: '1px solid ' + _globalStyles.lightGrey,
			color: _globalStyles.darkGrey,
			borderRadius: '4px',
			fontSize: '16px',
			lineHeight: '18px',
			padding: '14px 36px 14px 18px',
			appearance: 'none',
			cursor: 'pointer',
			background: '#F6F6F6 url(' + _dropdownIcon2.default + ') no-repeat calc(100% - 16px) center'
		}
	
	}, _css2['@media (min-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		'& label': {
			fontSize: '18px',
			lineHeight: '22px'
		},
		'& select': {
			width: '200px'
		}
	}, _css2['@media (min-width: ' + _globalStyles.tabletLandscapeMaxWidthBreakpoint + 'px)'] = {
		'& label': {
			fontSize: '22px',
			lineHeight: '27px'
		},
		'& select': {
			minWidth: '300px'
		}
	}, _css2));
	
	var tabPageWrapper = /*#__PURE__*/exports.tabPageWrapper = (0, _emotion.css)((_css3 = {
		borderTop: '1px solid ' + _globalStyles.lightGrey,
		backgroundColor: '#F6F6F6',
		width: '100%'
	}, _css3['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		paddingTop: 0,
		borderTop: 'none'
	}, _css3));
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingXLarge, /*#__PURE__*/(0, _emotion.css)((_css4 = {
		width: '525px'
	}, _css4['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		lineHeight: '47px'
	}, _css4['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		lineHeight: '23px',
		width: '286px'
	}, _css4)));
	
	var subTitleStyle = exports.subTitleStyle = (0, _emotion.cx)(_globalStyles.headingMedium, /*#__PURE__*/(0, _emotion.css)((_css5 = {}, _css5['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
		fontSize: '16px',
		lineHeight: '18px'
	}, _css5)));
	
	var locationDropdownStyle = /*#__PURE__*/exports.locationDropdownStyle = (0, _emotion.css)((_css6 = {
		'& label': _extends({}, _globalStyles.museo500, {
			display: 'block'
		}),
		'& select': {
			marginTop: '20px',
			width: '100%',
			display: 'block',
			border: '1px solid ' + _globalStyles.lightGrey,
			color: _globalStyles.darkGrey,
			borderRadius: '4px',
			fontSize: '16px',
			lineHeight: '18px',
			padding: '14px 36px 14px 18px',
			appearance: 'none',
			cursor: 'pointer',
			background: '#F6F6F6 url(' + _dropdownIcon2.default + ') no-repeat calc(100% - 16px) center'
		}
	
	}, _css6['@media (min-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'none !important'
	}, _css6));

/***/ }),

/***/ 1157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _kebabCase = __webpack_require__(678);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _pageHeader = __webpack_require__(19);
	
	var _cards = __webpack_require__(17);
	
	var _supportCard = __webpack_require__(970);
	
	var _audienceIcon = __webpack_require__(105);
	
	var _audienceIcon2 = _interopRequireDefault(_audienceIcon);
	
	var _bg = __webpack_require__(3740);
	
	var _bg2 = _interopRequireDefault(_bg);
	
	var _filterDropDown = __webpack_require__(253);
	
	var _audienceFilter = __webpack_require__(374);
	
	var _link = __webpack_require__(9);
	
	var _pagination = __webpack_require__(78);
	
	var _navManager = __webpack_require__(22);
	
	var _supportOrganisationsManager = __webpack_require__(1041);
	
	var _supportOrganisations = __webpack_require__(1073);
	
	var _globalStyles = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var regionPropType = _propTypes2.default.shape({
		edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			node: _propTypes2.default.shape({
				title: _propTypes2.default.string,
				parent_region: _propTypes2.default.string
			})
		}))
	});
	
	var SupportOrganisationsBrowsePage = function (_React$PureComponent) {
		_inherits(SupportOrganisationsBrowsePage, _React$PureComponent);
	
		function SupportOrganisationsBrowsePage(props, context) {
			_classCallCheck(this, SupportOrganisationsBrowsePage);
	
			var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props, context));
	
			_this.audienceFilter = function () {
				return _react2.default.createElement(_audienceFilter.AudienceFilter, {
					audiences: [{ id: 'for-healthcare-professionals', title: 'For Health Professionals' }, { id: 'for-myself', title: 'For Myself' }, { id: 'family-and-carers', title: 'For Family & Carers' }].map(function (a) {
						return _extends({}, a, {
							icon: _react2.default.createElement(_audienceIcon2.default, { audience: a, size: 12 })
						});
					}),
					activeFilters: [],
					onChange: function onChange(activeFilters) {
						var link = (0, _supportOrganisationsManager.linkWithFilter)({ audiences: activeFilters });
						(0, _link.navigateTo)(link);
					}
				});
			};
	
			_this.onPageChange = function (page) {
				var link = (0, _supportOrganisationsManager.linkWithFilter)({
					parentRegion: (0, _kebabCase2.default)(_this.props.pathContext.parentRegion),
					childRegion: (0, _kebabCase2.default)(_this.props.pathContext.childRegion),
					page: page
				});
				(0, _link.navigateTo)(link);
			};
	
			_this.getRegion = function (region) {
				var childRegion = _this.props.data.childRegions.edges.find(function (_ref) {
					var node = _ref.node;
					return node.title === region;
				});
	
				return childRegion ? childRegion.node.parent_region : region;
			};
	
			_this.regions = (0, _supportOrganisationsManager.prepareRegions)(props.data);
			return _this;
		}
	
		SupportOrganisationsBrowsePage.prototype.selectParentRegion = function selectParentRegion(e) {
			var link = (0, _supportOrganisationsManager.linkWithFilter)({ parentRegion: e.target.value });
			(0, _link.navigateTo)(link);
		};
	
		SupportOrganisationsBrowsePage.prototype.selectChildRegion = function selectChildRegion(e) {
			var link = (0, _supportOrganisationsManager.linkWithFilter)({
				parentRegion: (0, _kebabCase2.default)(this.props.pathContext.parentRegion),
				childRegion: e.target.value
			});
			(0, _link.navigateTo)(link);
		};
	
		SupportOrganisationsBrowsePage.prototype.render = function render() {
			var _this2 = this;
	
			var _props$pathContext = this.props.pathContext,
			    parentRegion = _props$pathContext.parentRegion,
			    childRegion = _props$pathContext.childRegion,
			    pageNumber = _props$pathContext.pageNumber,
			    totalPages = _props$pathContext.totalPages;
			var _props$data = this.props.data,
			    page = _props$data.page,
			    organisations = _props$data.organisations;
	
			var pageSettings = page.edges[0].node;
	
			var parentRegions = Object.keys(this.regions).map(function (region) {
				return {
					name: region,
					value: (0, _kebabCase2.default)(region)
				};
			});
			var childRegions = parentRegion ? this.regions[parentRegion].map(function (region) {
				return {
					name: region,
					value: (0, _kebabCase2.default)(region)
				};
			}) : null;
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: 'Support Organisations' },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: 'InsideOut - Support Organisations' })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: '#F26C22 url(' + _bg2.default + ') no-repeat 95% 100%',
					titleText: pageSettings.heading,
					titleTextColor: '#fff',
					subTitleText: pageSettings.body,
					subTitleTextColor: '#fff'
				}),
				_react2.default.createElement(
					'div',
					{ className: _supportOrganisations.locationSelectorStyle },
					_react2.default.createElement(
						'div',
						{ className: _supportOrganisations.locationSelectorInnerStyle },
						_react2.default.createElement(
							'label',
							{ htmlFor: 'location-state' },
							'Browse support organisations in'
						),
						_react2.default.createElement(
							'select',
							{ id: 'location-state', name: 'location-state', onChange: this.selectParentRegion },
							_react2.default.createElement(
								'option',
								{ value: '' },
								'Select a State'
							),
							parentRegions.map(function (region) {
								return _react2.default.createElement(
									'option',
									{
										key: region.value,
										value: region.value,
										selected: (0, _kebabCase2.default)(parentRegion) == region.value
									},
									region.name
								);
							})
						),
						childRegions && childRegions.length > 0 && _react2.default.createElement(
							'select',
							{
								id: 'location-region',
								name: 'location-region',
								onChange: this.selectChildRegion.bind(this)
							},
							_react2.default.createElement(
								'option',
								{ value: '' },
								'Select a Region'
							),
							childRegions.map(function (region) {
								return _react2.default.createElement(
									'option',
									{
										key: region.value,
										value: region.value,
										selected: (0, _kebabCase2.default)(childRegion) == region.value
									},
									region.name
								);
							})
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _globalStyles.sideBarLayout.mobileFilters },
					_react2.default.createElement(
						_filterDropDown.FilterDropDown,
						{
							componentName: 'Location',
							anchorTo: '.' + _globalStyles.sideBarLayout.mobileFilters,
							className: _supportOrganisations.locationDropdownStyle
						},
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.sideBarLayout.mobileFiltersDropDown },
							_react2.default.createElement(
								'label',
								{ htmlFor: 'mobile-location-state' },
								'Browse support organisations in'
							),
							_react2.default.createElement(
								'select',
								{
									id: 'mobile-location-state',
									name: 'mobile-location-state',
									onChange: this.selectParentRegion
								},
								_react2.default.createElement(
									'option',
									{ value: '' },
									'Select a State'
								),
								parentRegions.map(function (region) {
									return _react2.default.createElement(
										'option',
										{
											key: region.value,
											value: region.value,
											selected: (0, _kebabCase2.default)(parentRegion) == region.value
										},
										region.name
									);
								})
							),
							childRegions && _react2.default.createElement(
								'select',
								{
									id: 'mobile-location-region',
									name: 'mobile-location-region',
									onChange: this.selectChildRegion.bind(this)
								},
								_react2.default.createElement(
									'option',
									{ value: '' },
									'Select a Region'
								),
								childRegions.map(function (region) {
									return _react2.default.createElement(
										'option',
										{
											key: region.value,
											value: region.value,
											selected: (0, _kebabCase2.default)(childRegion) == region.value
										},
										region.name
									);
								})
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _supportOrganisations.tabPageWrapper },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.sideBarLayout.wrapper },
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.sideBarLayout.leftSide(36) },
							organisations && organisations.edges.length > 0 && _react2.default.createElement(
								_cards.Cards,
								{ columns: 1, scrollable: false },
								organisations.edges.map(function (_ref2, index) {
									var node = _ref2.node;
									return _react2.default.createElement(_supportCard.SupportCard, {
										key: index,
										to: (0, _navManager.idToLink)(node.id),
										organisation: 'Organisation',
										location: _this2.getRegion(node.region),
										audiences: (0, _supportOrganisationsManager.fullAudiences)(node.audiences),
										type: node.type,
										title: node.title,
										body: node.extract,
										image: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src
									});
								})
							)
						)
					)
				),
				totalPages !== 1 && _react2.default.createElement(_pagination.Pagination, {
					initialPage: pageNumber,
					pageCount: totalPages,
					onPageChange: this.onPageChange
				})
			);
		};
	
		return SupportOrganisationsBrowsePage;
	}(_react2.default.PureComponent);
	
	SupportOrganisationsBrowsePage.propTypes = {
		pathContext: _propTypes2.default.shape({
			pageNumber: _propTypes2.default.number.isRequired,
			totalPages: _propTypes2.default.number.isRequired,
			parentRegion: _propTypes2.default.string,
			childRegion: _propTypes2.default.string,
			audience: _propTypes2.default.string
		}).isRequired,
		data: _propTypes2.default.shape({
			parentRegions: regionPropType,
			childRegions: regionPropType,
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired
					})
				}))
			}),
			organisations: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						type: _propTypes2.default.string.isRequired,
						title: _propTypes2.default.string.isRequired,
						extract: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						region: _propTypes2.default.string.isRequired,
						audiences: _propTypes2.default.arrayOf(_propTypes2.default.string),
						attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							file: _propTypes2.default.string
						})),
						contact_information: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							type: _propTypes2.default.string,
							text: _propTypes2.default.string,
							destination: _propTypes2.default.string
						})),
						fields: _propTypes2.default.shape({
							thumbnail_image: _propTypes2.default.shape({
								childImageSharp: _propTypes2.default.shape({
									resize: _propTypes2.default.shape({
										src: _propTypes2.default.string
									})
								})
							})
						})
					})
				}))
			}).isRequired
		}).isRequired
	};
	exports.default = SupportOrganisationsBrowsePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-support-organisations-index-js-4e5ccc770beb78751c1c.js